const trust = [
  { icon: 'ri-bank-card-line', label: '$0 charged today' },
  { icon: 'ri-shield-check-line', label: 'Vetted cleaners' },
  { icon: 'ri-brush-2-line', label: 'Supplies included' },
];

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-background-50">
      <div className="pointer-events-none absolute -top-40 -left-32 w-[420px] h-[420px] md:w-[560px] md:h-[560px] rounded-full bg-primary-300 blur-[110px] opacity-70" aria-hidden="true"></div>
      <div className="pointer-events-none absolute -bottom-48 -right-32 w-[440px] h-[440px] md:w-[580px] md:h-[580px] rounded-full bg-accent-300 blur-[120px] opacity-70" aria-hidden="true"></div>

      <div className="relative max-w-6xl mx-auto px-4 md:px-6 py-14 md:py-24 grid grid-cols-1 lg:grid-cols-[1fr_420px] gap-10 lg:gap-16 items-center">
        <div className="anim-fade-up lg:pt-4">
          <div className="flex flex-wrap gap-2 mb-5">
            <span className="bg-background-100 border border-primary-200 text-primary-700 text-xs font-semibold px-3 py-1.5 rounded-full whitespace-nowrap">Chicago &amp; suburbs</span>
            <span className="grad-brand text-foreground-950 text-xs font-bold px-3 py-1.5 rounded-full whitespace-nowrap">−10% first booking</span>
          </div>
          <h1 className="font-heading font-bold text-foreground-950 text-[2.1rem] leading-[1.08] md:text-5xl lg:text-[3.4rem] tracking-tight">
            Move-out and home cleaning, priced in <span className="text-accent-600">30 seconds.</span>
          </h1>
          <p className="mt-5 text-base md:text-lg text-foreground-600 max-w-xl leading-relaxed">
            Pick your home size, see the exact price, book a time. Your card is saved securely and charged only after the cleaning is done.
          </p>
        </div>
        <div className="anim-fade-up anim-delay-1 w-full">
          <a href="#book" className="w-full flex items-center justify-center gap-3 grad-cta text-background-50 font-heading font-bold text-lg md:text-xl px-8 py-4 md:py-5 rounded-full whitespace-nowrap cursor-pointer transition-all duration-200 shadow-pink hover:-translate-y-0.5 hover:shadow-pink-lg">
            Get my price
            <span className="w-5 h-5 flex items-center justify-center"><i className="ri-arrow-right-line"></i></span>
          </a>
          <ul className="mt-8 flex flex-col gap-4">
            {trust.map((t) => (
              <li key={t.label} className="flex items-center gap-3 text-sm md:text-base font-medium text-foreground-900">
                <span className="w-9 h-9 rounded-full bg-primary-50 text-primary-600 flex items-center justify-center shrink-0"><i className={t.icon}></i></span>
                {t.label}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}